import {getError, getInputErrorMessage, hasErrorInput} from "../../utils";
import Select2 from "../Select2";
import {
  TextInput,
  PasswordInput,
  Label,
  FormGroup,
  FormGroupInput,
  EmailInput,
  RadioInput,
  Button
} from "../../components";
import {
  getSelectedValue,
} from "../../utils/select-utils";
import {Modal} from "flowbite-react";
import { STATUS_USER } from "../../constants/app";


function UserAddModal({showModal, setShowModal, selectOptionRole, formCreateUserData, setFormCreateUserData, formError, buttonId, handleSubmit}) {
  const halfWidthRegex = /^[\u0020-\u007E\uFF61-\uFF9F]*$/;

  const handleInputAddUserModalChange = (e) => {
    if (e.target.name === 'password' && halfWidthRegex.test(e.target.value) === false) {
        return;
    }

    setFormCreateUserData({
      ...formCreateUserData,
      [e.target.name]: e.target.value
    });
  };

  const handleSelectAddUserModalChange = (selectOption, name) => {
    var value = '';
    if (selectOption) {
      value = selectOption.value
    }

    setFormCreateUserData({
      ...formCreateUserData,
      [name]: value
    })
  };

  return (
    <Modal show={showModal} className="z-[9999]" onClose={() => setShowModal(false)}>
      <Modal.Header className="p-[12px] xl:p-[24px] text-lg xl:text-xl">
        新しいユーザーマスタを追加する
      </Modal.Header>
      <Modal.Body className="p-[12px] xl:p-[24px]">
        <FormGroup direction="horizontal">
          <Label text="ユーザーID" required={true} htmlFor="username" className="w-[180px]"/>
          <FormGroupInput className="flex-col" error={getInputErrorMessage(getError(formError), "username")}>
            <TextInput type="text" name="username" id="username" className="w-[400px] text-gray-900" maxLength="20" autoFocus
                       value={formCreateUserData.username} onChange={handleInputAddUserModalChange}
                       hasError={hasErrorInput(formError.errors, "username")}/>
          </FormGroupInput>
        </FormGroup>
        <FormGroup direction="horizontal">
          <Label text="パスワード" required={true} htmlFor="password" className="w-[180px]"/>
          <FormGroupInput className="flex-col" error={getInputErrorMessage(getError(formError), "password")}>
            <PasswordInput name="password" id="password" className="w-[400px] text-gray-900" maxLength="64" viewPassword={true}
                           value={formCreateUserData.password} onChange={handleInputAddUserModalChange}
                           hasError={hasErrorInput(formError.errors, "password")}/>
          </FormGroupInput>
        </FormGroup>
        <FormGroup direction="horizontal">
          <Label text="ユーザー名" required={true} htmlFor="name" className="w-[180px]" />
          <FormGroupInput className="flex-col" error={getInputErrorMessage(getError(formError), "name")}>
            <TextInput type="text" name="name" id="name" className="w-[400px] text-gray-900" maxLength="40"
                       value={formCreateUserData.name} onChange={handleInputAddUserModalChange}
                       hasError={hasErrorInput(formError.errors, "name")}/>
          </FormGroupInput>
        </FormGroup>
        <FormGroup direction="horizontal">
          <Label text="メールアドレス" required={false} htmlFor="email" className="w-[180px]" />
          <FormGroupInput className="flex-col" error={getInputErrorMessage(getError(formError), "email")}>
            <EmailInput name="email" id="email" className="w-[400px] text-gray-900" maxLength="200"
                        value={formCreateUserData.email} onChange={handleInputAddUserModalChange}
                        hasError={hasErrorInput(formError.errors, "email")}/>
          </FormGroupInput>
        </FormGroup>
        <FormGroup direction="horizontal">
          <Label text="ロール" required={true} htmlFor="role" className="w-[180px]"/>
          <FormGroupInput className="flex-col" error={getInputErrorMessage(getError(formError), "role")}>
            <Select2
              options={selectOptionRole}
              className='xl:text-base text-gray-900 w-[400px]'
              classNamePrefix="react-select"
              value={getSelectedValue(selectOptionRole, formCreateUserData.role)}
              maxLength='15'
              placeholder=''
              onChange={(getSelectOptionRole) => handleSelectAddUserModalChange(getSelectOptionRole, 'role')}
              name="role"
              hasError={hasErrorInput(formError.errors, "role")}
            />
          </FormGroupInput>
        </FormGroup>
        <FormGroup direction="horizontal">
          <Label text="状態" htmlFor="status" className="w-[180px]"/>
          <FormGroupInput className="flex-col" error={getInputErrorMessage(getError(formError), "status")}>
            <div className="flex flex-row h-[40px]">
              <RadioInput
                name="status"
                id="status_not_active"
                value={STATUS_USER.RESIGN}
                onChange={handleInputAddUserModalChange}
                checked={Number(formCreateUserData.status) === STATUS_USER.RESIGN}
                label="無効"
              />
              <RadioInput
                name="status"
                id="status_active"
                value={STATUS_USER.ACTIVE}
                onChange={handleInputAddUserModalChange}
                checked={Number(formCreateUserData.status) === STATUS_USER.ACTIVE}
                label="有効"
                className="ml-[32px]"
              />
            </div>
          </FormGroupInput>
        </FormGroup>
      </Modal.Body>
      <Modal.Footer className="space-x-[32px] h-[80px]">
        <div className="w-1/2">
          <Button color="light" className="w-full" onClick={() => setShowModal(false)}>
            閉じる
          </Button>
        </div>
        <div className="w-1/2">
          <Button color="primary" className="w-full" onClick={handleSubmit} id={buttonId}>
            新規追加
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default UserAddModal;
